import React, { useState, useEffect } from 'react'
import { Box, Button, Select, SelectDate } from 'stylewhere/components'
import { filtersConfig, Filter } from './filtersConfig'
import moment from 'moment'
import { T, __ } from 'stylewhere/i18n'
import { ShippingOperationConfig } from 'stylewhere/shared'

export interface FiltersProps {
  operation: ShippingOperationConfig
  filterParams: any
  onApplyFilters: (newFilters: any) => void
  resetFilters: number
  disabled?: boolean
}

export const Filters: React.FC<FiltersProps> = ({
  operation,
  filterParams,
  onApplyFilters,
  resetFilters,
  disabled
}) => {
  const [tempFilters, setTempFilters] = useState(filterParams)
  const [tempResetFilters, setTempResetFilters] = useState(resetFilters)

  useEffect(() => {
    if (resetFilters > 0 && resetFilters > tempResetFilters) {
      setTempFilters(filterParams)
      setTempResetFilters(resetFilters)
    }
  }, [resetFilters, filterParams, tempResetFilters])

  const handleSelectChange = (key) => (selected) => {
    const values = Array.isArray(selected) ? selected.map((s) => s.value) : []
    const newFilters = { ...tempFilters, [key]: values }
    setTempFilters(newFilters)
    if (getFilterToShow().length === 1) {
      handleApply(newFilters)
    }
  }

  const handleDateChange = (selected: string | { start: string; end: string } | undefined) => {
    const newFilters = { ...tempFilters }

    delete newFilters.creationDateStart
    delete newFilters.creationDateEnd

    if (typeof selected === 'string') {
      if (selected === 'today') {
        const now = moment().startOf('day')
        newFilters.creationDateStart = now.format('YYYY-MM-DDTHH:mm:ss+0000')
        newFilters.creationDateEnd = now.endOf('day').format('YYYY-MM-DDTHH:mm:ss+0000')
      } else if (selected === 'lastweek') {
        const now = moment().startOf('day')
        newFilters.creationDateStart = moment(now).subtract(6, 'days').format('YYYY-MM-DDTHH:mm:ss+0000')
        newFilters.creationDateEnd = now.endOf('day').format('YYYY-MM-DDTHH:mm:ss+0000')
      }
      newFilters.creationDate = selected
    } else if (selected && typeof selected === 'object' && selected.start && selected.end) {
      const startApi = moment(selected.start, 'YYYY-MM-DD').startOf('day').format('YYYY-MM-DDTHH:mm:ss+0000')
      const endApi = moment(selected.end, 'YYYY-MM-DD').endOf('day').format('YYYY-MM-DDTHH:mm:ss+0000')
      newFilters.creationDateStart = startApi
      newFilters.creationDateEnd = endApi
      newFilters.creationDate = selected
    } else {
      delete newFilters.creationDate
      delete newFilters.creationDateStart
      delete newFilters.creationDateEnd
    }
    setTempFilters(newFilters)
    if (getFilterToShow().length === 1) {
      handleApply(newFilters)
    }
  }

  const handleApply = (data?: any) => {
    const clean = Object.entries(data ?? tempFilters).reduce((acc, [key, value]) => {
      if (key === 'creationDate') return acc
      if (value !== undefined && value !== null && (Array.isArray(value) ? value.length > 0 : value !== ''))
        acc[key] = value
      return acc
    }, {})
    onApplyFilters(clean)
  }

  const getFilterToShow = () => {
    const filters: Filter[] = []
    filtersConfig.forEach((f) => {
      filters.push(f)
    })
    return filters
  }

  const filters = getFilterToShow()
  return (
    <Box row style={{ alignItems: 'center', gap: 15 }}>
      {filters.map((f) => {
        const options = f.getOptions(__, T, operation)
        if (f.type === 'select') {
          const value = (tempFilters[f.key] ?? []).length
            ? options.filter((opt) => (tempFilters[f.key] ?? []).includes(opt.value))
            : null
          return (
            <Box mb={0} mr={2} key={f.key} style={{ minWidth: 220 }}>
              <Select
                label={f.label(__, T)}
                config={{ value: 'value', label: 'label' }}
                options={options}
                multiple={f.multiple}
                value={value}
                onSelect={handleSelectChange(f.key)}
                placeholder={f.label(__, T)}
                disabled={disabled}
              />
            </Box>
          )
        } else if (f.type === 'date') {
          return (
            <Box mb={0} key={f.key} mr={2} style={{ minWidth: 220 }}>
              <SelectDate
                label={f.label(__, T)}
                value={tempFilters.creationDate}
                options={options}
                onChange={handleDateChange}
                placeholder={f.label(__, T)}
                disabled={disabled}
              />
            </Box>
          )
        }
        return null
      })}
      {filters.length > 1 && (
        <Button title={__(T.misc.apply)} onClick={handleApply} variant="primary" disabled={disabled} />
      )}
    </Box>
  )
}
